export const parkingPalette = {
    50: '#fff5e6',
    100: '#ffe0b3',
    200: '#ffc94d',
    300: '#ffaa00',
    400: '#cc7400',
    500: '#f39200',
    600: '#804200',
    700: '#4d2600',
    800: '#1a0b00',
    900: '#080300'
}
